import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD,
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID,
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_FAILURE,
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_SUCCESS,

    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE,
    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_SUCCESS,
    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_FAILURE,

    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE,
    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_SUCCESS,
    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_FAILURE,

    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE,
    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_SUCCESS,
    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_FAILURE,

    ACTION_GROUPITEMTEMPLATECATEGORY_CLEAR,
    ACTION_GROUPITEMTEMPLATECATEGORY_FILTER,

    GroupItemTemplateCategoryAction
} from '../actions/groupItemTemplateCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IGroupItemTemplateCategoryState {
    formData: Dtos.GroupItemTemplateCategory | Dtos.GroupItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.GroupItemTemplateCategory[];
}

const initialState: IGroupItemTemplateCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: IGroupItemTemplateCategoryState, _isLoading: boolean): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IGroupItemTemplateCategoryState,
    formData: Dtos.GroupItemTemplateCategory | Dtos.GroupItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IGroupItemTemplateCategoryState, formFilter: IFormFilter): IGroupItemTemplateCategoryState {

    const groupItemTemplateCategorys: Dtos.GroupItemTemplateCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = groupItemTemplateCategorys ? groupItemTemplateCategorys.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IGroupItemTemplateCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IGroupItemTemplateCategoryState, propertiesToClear?: string[]): IGroupItemTemplateCategoryState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IGroupItemTemplateCategoryState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IGroupItemTemplateCategoryState, _isSaving: boolean): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IGroupItemTemplateCategoryState,
    formData: Dtos.GroupItemTemplateCategory | Dtos.GroupItemTemplateCategory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IGroupItemTemplateCategoryState, _isCreating: boolean): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IGroupItemTemplateCategoryState,
    formData: Dtos.GroupItemTemplateCategory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IGroupItemTemplateCategoryState, _isValidating: boolean): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IGroupItemTemplateCategoryState,
    formData: Dtos.GroupItemTemplateCategory,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IGroupItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryState {
    const newState: IGroupItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const GroupItemTemplateCategoryReducer: Reducer<IGroupItemTemplateCategoryState> = (state: IGroupItemTemplateCategoryState = initialState, action: GroupItemTemplateCategoryAction) => {
    switch (action.type) {
        case ACTION_GROUPITEMTEMPLATECATEGORY_LOAD:
        case ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_GROUPITEMTEMPLATECATEGORY_SAVE:
            return saving(state, true);
        case ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_CREATE:
            return creating(state, true);
        case ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE:
            return validating(state, true);
        case ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_GROUPITEMTEMPLATECATEGORY_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default GroupItemTemplateCategoryReducer;